import { Box, Paper, Typography, Divider, CardMedia } from '@mui/material';
import { envAssets } from '../../environment';
import { Trans } from "@lingui/macro";

export default function WelcomeComponent() {
    let wineryIcon = envAssets('images/icons/pin-03.png');
    let natureIcon = envAssets('images/icons/pin-02.png');
    let culturalIcon = envAssets('images/icons/pin-01.png');

    return (
        <Box ml={3} mr={2} height={'100%'}>
            <Paper elevation={0} sx={{
                boxSizing: 'border-box',
                borderRadius: 2,
                bgcolor: "#F7F7F7", border: "1px solid #DBDBDB", width: '100%', height: '100%',
                overflow: 'scroll', overflowX: 'hidden'
            }}>
                <Box px={2} height={'100%'} display={'flex'} flexDirection={'column'}>
                    <Typography px={{ xs: 1, md: 2, lg: 3, xl: 10 }} pb={{ xs: 1, lg: 2, xl: 3 }} pt={{ xs: 3, xl: 5 }} textAlign={'center'} variant="h5" fontSize={{ xs: '1.35rem', md: '1.6rem', lg: '1.6rem' }}
                        fontFamily="Playfair Display" ><Trans>Избери обект от картата вляво</Trans></Typography>
                    <Divider sx={{ my: '16px !important', mx: 'auto !important', borderBottomWidth: 2, width: '90%' }} variant="middle" />
                    <Typography px={{ xs: 2, xl: 3 }} py={{ xs: 1, xl: 3 }} color={"text.secondary"} variant="subtitle2" sx={{ fontSize: { xs: 14, xl: 16 }, fontWeight: 400 }}>
                        <Trans>Можете да изберете всяка от винарните в региона на интерактивната дигитална карта и да разгледате повече информация за нея,
                            както и да намерите близките природни и културни забележителности, които да посетите.</Trans>
                        <br></br>
                        <br></br>
                        <Trans>Ето и значението на иконките:</Trans>
                    </Typography>
                    {/* <Typography px={{ xs: 2, xl: 4 }} py={{ xs: 1, xl: 3 }} color={"text.secondary"} variant="subtitle2" sx={{ fontSize: { xs: 14, xl: 16 }, fontWeight: 400 }}>
                        Ето и значението на иконките:
                    </Typography> */}
                    <Paper elevation={0} sx={{ borderRadius: 2, bgcolor: "#F7F7F7", border: "1px solid #DBDBDB", marginX: { xs: 1, md: 2 }, marginTop: { xs: 2, xl: 0 } }} >
                        <Box px={2} py={1}>
                            <Box display={'flex'} alignItems={'center'} py={1}>
                                <CardMedia
                                    loading="lazy"
                                    component="img"
                                    sx={{ height: '35px !important', width: 35, objectFit: 'contain', pr: 1 }}
                                    image={wineryIcon}
                                    alt={'winery icon'}
                                />
                                <Typography fontSize={{ xs: 14, xl: 16 }}>
                                    <Trans>Винарна</Trans>
                                </Typography>
                            </Box>
                            <Box display={'flex'} alignItems={'center'} py={1}>
                                <CardMedia
                                    loading="lazy"
                                    component="img"
                                    sx={{ height: '35px !important', width: 35, objectFit: 'contain', pr: 1 }}
                                    image={natureIcon}
                                    alt={'nature icon'}
                                />
                                <Typography fontSize={{ xs: 14, xl: 16 }}>
                                    <Trans>Културен обект</Trans>
                                </Typography>
                            </Box>
                            <Box display={'flex'} alignItems={'center'} py={1}>
                                <CardMedia
                                    loading="lazy"
                                    component="img"
                                    sx={{ height: '35px !important', width: 35, objectFit: 'contain', pr: 1 }}
                                    image={culturalIcon}
                                    alt={'cultural icon'}
                                />
                                <Typography fontSize={{ xs: 14, xl: 16 }}>
                                    <Trans>Природна забележителност</Trans>
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                    {/* <CardMedia
                        loading="lazy"
                        component="img"
                        sx={{ height: '45% !important', objectFit: 'contain', width: { xs: '80%', xl: '100%' }, margin: 'auto', py: 5 }}
                        image={'https://wineimport { envAssets } from '../../environment';
tours.netea.bg/wp-content/themes/themeForReact/assets/images/grape-img.png'}
                        alt={'logo'}
                    /> */}
                </Box>
            </Paper >
        </Box >
    )
}